import { useEffect, useState } from 'react'

export function useMediaQuery(query: string): boolean {
  const get = () =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  const [match, setMatch] = useState(get)

  useEffect(() => {
    const mq = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatch(e.matches)
    setMatch(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])

  return match
}
